import { ICompletionStatus } from "../Types/ICompletionStatus";
import { IQuestionnaireSection } from "../Types/Products/IQuestionnaireSection";

export type MaybeDate = Date | string | number | null | undefined;

export const UNSET_DATE = new Date(Date.UTC(1, 0, 1, 0, 0, 0, 0));

export const toDate = (v: Exclude<MaybeDate, null | undefined>): Date => {
  if (v instanceof Date) return v;
  if (typeof v === "number") return new Date(v);
  // Force UTC if only YYYY-MM-DD provided
  const iso = /^\d{4}-\d{2}-\d{2}$/.test(v) ? `${v}T00:00:00Z` : v;
  return new Date(iso);
};

export const isSetDate = (d: MaybeDate): boolean => {
  if (d == null || d === "") return false;

  const dt = toDate(d);
  if (Number.isNaN(dt.getTime())) return false;

  // Treat sentinel (0001) and the 1901 quirk as unset
  if (dt.getTime() === UNSET_DATE.getTime()) return false;
  if (dt.getUTCFullYear() <= 1901) return false;

  return true;
};

export const formatUkDateSafe = (value: unknown): string => {
  if (value == null) return "—";

  // .NET DateTime.MinValue (0001-01-01) and similar sentinels mean "no date"
  if (!isSetDate(value as MaybeDate)) return "—";

  // If it's already a Date
  if (value instanceof Date) {
    return isNaN(value.getTime())
      ? "—"
      : new Intl.DateTimeFormat("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }).format(value);
  }

  // If it's a string/number etc.
  const d = new Date(value as any);
  if (isNaN(d.getTime())) return "—";

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(d);
};
